import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Injectable({ providedIn: 'root' })

export class AccordionStateService {
    openPanels: { [key: string]: boolean } = {};
    private readonly STORAGE_KEY = 'productFilterAccordionState';

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.loadState();
    }

    saveState(): void {
        if (isPlatformBrowser(this.platformId)) {
            sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.openPanels));
        }
    }

    loadState(): void {
        if (!isPlatformBrowser(this.platformId)) return;
        const savedState = sessionStorage.getItem(this.STORAGE_KEY);
        if (savedState) {
            try {
                this.openPanels = JSON.parse(savedState);
            } catch (e) {
                console.error('Error parsing accordion state', e);
                this.openPanels = {};
            }
        }
    }

    clearState(): void {
        this.openPanels = {};
        if (isPlatformBrowser(this.platformId)) {
            sessionStorage.removeItem(this.STORAGE_KEY);
        }
    }
}